module.exports = __webpack_public_path__ + "static/media/ct.8d6561cd.jpeg";